import { Editor } from '@tinymce/tinymce-react';
import React, { forwardRef } from 'react';
import { RichTextEditorProps } from './RichTextEditor.types';

import './RichTextEditor.scss';

const editorToolbar = `
                  undo redo | cut copy paste | code | styles | fontfamily | fontsize | bold italic underline strikethrough forecolor backcolor |
                  link unlink image emoticons | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent hr | table tabledelete |
                  tableprops tablerowprops tablecellprops | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol
                `;

const defaultConfig = {
  menubar: false,
  resize: false,
  preview_styles: false,
  relative_urls: false,
  convert_urls: false,
  height: '340',
  statusbar: false,
  toolbar_mode: 'wrap',
  placeholder: '',
  plugins: 'textpattern link image emoticons code lists advlist hr table powerpaste',
  contextmenu: 'undo redo | cut copy paste',
  toolbar: editorToolbar,
  powerpaste_allow_local_images: true,
  powerpaste_googledocs_import: 'merge',
  powerpaste_word_import: 'merge',
  powerpaste_html_import: 'merge',
};

/**
 * Secondary description on Storybook Docs. I can have multiple lines and
   bullets!
  - The primary component has:
    - CSS modules
    - Tailwind styles
    - CSS variables
  - To make sure all different CSS channels are working
  */

const RichTextEditor: React.FC<RichTextEditorProps> = forwardRef<
  Editor,
  RichTextEditorProps
>(
  (
    {
      className = '',
      initialValue = '',
      placeholder = '',
      height = '340',
      tinymceApiKey,
      tinymceConfig = {},
      onChange,
      imagesUploadHandler,
      ...props
    },
    ref
  ) => {
    return (
      <div
        data-testid='rich-text-editor-component'
        className={`rich-text-editor__container ${className}`}
      >
        <Editor
          ref={ref}
          apiKey={tinymceApiKey}
          onChange={(e: any) => onChange(e)}
          initialValue={initialValue}
          init={{
            ...defaultConfig,
            height,
            placeholder,
            images_upload_handler: imagesUploadHandler,
            ...tinymceConfig,
          }}
          {...props}
        />
      </div>
    );
  }
);

export default RichTextEditor;
